"use strict";
// Generated from ./src/lang/Scheme.g4 by ANTLR 4.9.0-SNAPSHOT
// @ts-ignore
Object.defineProperty(exports, "__esModule", { value: true });
exports.DottedListContext = exports.ListContext = exports.UnquoteSplicingContext = exports.UnquoteContext = exports.QuasiquoteContext = exports.QuoteContext = exports.IdentifierContext = exports.BoolContext = exports.NumberContext = exports.StringContext = exports.ExpressionContext = exports.ProgramContext = exports.SchemeParser = void 0;
const ATNDeserializer_1 = require("antlr4ts/atn/ATNDeserializer");
const ParserATNSimulator_1 = require("antlr4ts/atn/ParserATNSimulator");
const FailedPredicateException_1 = require("antlr4ts/FailedPredicateException");
const Utils = require("antlr4ts/misc/Utils");
const Parser_1 = require("antlr4ts/Parser");
const ParserRuleContext_1 = require("antlr4ts/ParserRuleContext");
const RecognitionException_1 = require("antlr4ts/RecognitionException");
const VocabularyImpl_1 = require("antlr4ts/VocabularyImpl");
class SchemeParser extends Parser_1.Parser {
    constructor(input) {
        super(input);
        this._interp = new ParserATNSimulator_1.ParserATNSimulator(SchemeParser._ATN, this);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return SchemeParser.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'Scheme.g4';
    }
    // @Override
    get ruleNames() {
        return SchemeParser.ruleNames;
    }
    // @Override
    get serializedATN() {
        return SchemeParser._serializedATN;
    }
    createFailedPredicateException(predicate, message) {
        return new FailedPredicateException_1.FailedPredicateException(this, predicate, message);
    }
    // @RuleVersion(0)
    program() {
        const _localctx = new ProgramContext(this._ctx, this.state);
        this.enterRule(_localctx, 0, SchemeParser.RULE_program);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 5;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                do {
                    {
                        {
                            this.state = 4;
                            this.expression();
                        }
                    }
                    this.state = 7;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                } while ((_la & ~0x1f) === 0 &&
                    ((1 << _la) &
                        ((1 << SchemeParser.T__0) |
                            (1 << SchemeParser.T__1) |
                            (1 << SchemeParser.T__2) |
                            (1 << SchemeParser.T__3) |
                            (1 << SchemeParser.T__4) |
                            (1 << SchemeParser.STRING) |
                            (1 << SchemeParser.NUMBER) |
                            (1 << SchemeParser.BOOL) |
                            (1 << SchemeParser.IDENTIFIER))) !==
                        0);
                this.state = 9;
                this.match(SchemeParser.EOF);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException_1.RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    expression() {
        let _localctx = new ExpressionContext(this._ctx, this.state);
        this.enterRule(_localctx, 2, SchemeParser.RULE_expression);
        let _la;
        try {
            this.state = 41;
            this._errHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this._input, 3, this._ctx)) {
                case 1:
                    _localctx = new StringContext(_localctx);
                    this.enterOuterAlt(_localctx, 1);
                    {
                        this.state = 11;
                        this.match(SchemeParser.STRING);
                    }
                    break;
                case 2:
                    _localctx = new NumberContext(_localctx);
                    this.enterOuterAlt(_localctx, 2);
                    {
                        this.state = 12;
                        this.match(SchemeParser.NUMBER);
                    }
                    break;
                case 3:
                    _localctx = new BoolContext(_localctx);
                    this.enterOuterAlt(_localctx, 3);
                    {
                        this.state = 13;
                        this.match(SchemeParser.BOOL);
                    }
                    break;
                case 4:
                    _localctx = new IdentifierContext(_localctx);
                    this.enterOuterAlt(_localctx, 4);
                    {
                        this.state = 14;
                        this.match(SchemeParser.IDENTIFIER);
                    }
                    break;
                case 5:
                    _localctx = new QuoteContext(_localctx);
                    this.enterOuterAlt(_localctx, 5);
                    {
                        this.state = 15;
                        this.match(SchemeParser.T__0);
                        this.state = 16;
                        this.expression();
                    }
                    break;
                case 6:
                    _localctx = new QuasiquoteContext(_localctx);
                    this.enterOuterAlt(_localctx, 6);
                    {
                        this.state = 17;
                        this.match(SchemeParser.T__1);
                        this.state = 18;
                        this.expression();
                    }
                    break;
                case 7:
                    _localctx = new UnquoteContext(_localctx);
                    this.enterOuterAlt(_localctx, 7);
                    {
                        this.state = 19;
                        this.match(SchemeParser.T__2);
                        this.state = 20;
                        this.expression();
                    }
                    break;
                case 8:
                    _localctx = new UnquoteSplicingContext(_localctx);
                    this.enterOuterAlt(_localctx, 8);
                    {
                        this.state = 21;
                        this.match(SchemeParser.T__3);
                        this.state = 22;
                        this.expression();
                    }
                    break;
                case 9:
                    _localctx = new ListContext(_localctx);
                    this.enterOuterAlt(_localctx, 9);
                    {
                        this.state = 23;
                        this.match(SchemeParser.T__4);
                        this.state = 27;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while ((_la & ~0x1f) === 0 &&
                            ((1 << _la) &
                                ((1 << SchemeParser.T__0) |
                                    (1 << SchemeParser.T__1) |
                                    (1 << SchemeParser.T__2) |
                                    (1 << SchemeParser.T__3) |
                                    (1 << SchemeParser.T__4) |
                                    (1 << SchemeParser.STRING) |
                                    (1 << SchemeParser.NUMBER) |
                                    (1 << SchemeParser.BOOL) |
                                    (1 << SchemeParser.IDENTIFIER))) !==
                                0) {
                            {
                                {
                                    this.state = 24;
                                    _localctx._elements = this.expression();
                                }
                            }
                            this.state = 29;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        this.state = 30;
                        this.match(SchemeParser.T__5);
                    }
                    break;
                case 10:
                    _localctx = new DottedListContext(_localctx);
                    this.enterOuterAlt(_localctx, 10);
                    {
                        this.state = 31;
                        this.match(SchemeParser.T__4);
                        this.state = 33;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        do {
                            {
                                {
                                    this.state = 32;
                                    _localctx._pre = this.expression();
                                }
                            }
                            this.state = 35;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        } while ((_la & ~0x1f) === 0 &&
                            ((1 << _la) &
                                ((1 << SchemeParser.T__0) |
                                    (1 << SchemeParser.T__1) |
                                    (1 << SchemeParser.T__2) |
                                    (1 << SchemeParser.T__3) |
                                    (1 << SchemeParser.T__4) |
                                    (1 << SchemeParser.STRING) |
                                    (1 << SchemeParser.NUMBER) |
                                    (1 << SchemeParser.BOOL) |
                                    (1 << SchemeParser.IDENTIFIER))) !==
                                0);
                        this.state = 37;
                        this.match(SchemeParser.T__6);
                        this.state = 38;
                        _localctx._post = this.expression();
                        this.state = 39;
                        this.match(SchemeParser.T__5);
                    }
                    break;
            }
        }
        catch (re) {
            if (re instanceof RecognitionException_1.RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    static get _ATN() {
        if (!SchemeParser.__ATN) {
            SchemeParser.__ATN = new ATNDeserializer_1.ATNDeserializer().deserialize(Utils.toCharArray(SchemeParser._serializedATN));
        }
        return SchemeParser.__ATN;
    }
}
exports.SchemeParser = SchemeParser;
SchemeParser.T__0 = 1;
SchemeParser.T__1 = 2;
SchemeParser.T__2 = 3;
SchemeParser.T__3 = 4;
SchemeParser.T__4 = 5;
SchemeParser.T__5 = 6;
SchemeParser.T__6 = 7;
SchemeParser.STRING = 8;
SchemeParser.NUMBER = 9;
SchemeParser.BOOL = 10;
SchemeParser.IDENTIFIER = 11;
SchemeParser.WHITESPACE = 12;
SchemeParser.COMMENT = 13;
SchemeParser.RULE_program = 0;
SchemeParser.RULE_expression = 1;
// tslint:disable:no-trailing-whitespace
SchemeParser.ruleNames = ['program', 'expression'];
SchemeParser._LITERAL_NAMES = [
    undefined,
    "'''",
    "'`'",
    "','",
    "',@'",
    "'('",
    "')'",
    "'.'"
];
SchemeParser._SYMBOLIC_NAMES = [
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    'STRING',
    'NUMBER',
    'BOOL',
    'IDENTIFIER',
    'WHITESPACE',
    'COMMENT'
];
SchemeParser.VOCABULARY = new VocabularyImpl_1.VocabularyImpl(SchemeParser._LITERAL_NAMES, SchemeParser._SYMBOLIC_NAMES, []);
SchemeParser._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x03\x0F.\x04\x02' +
    '\t\x02\x04\x03\t\x03\x03\x02\x06\x02\b\n\x02\r\x02\x0E\x02\t\x03\x02\x03' +
    '\x02\x03\x03\x03\x03\x03\x03\x03\x03\x03\x03\x03\x03\x03\x03\x03\x03\x03' +
    '\x03\x03\x03\x03\x03\x03\x03\x03\x03\x03\x03\x07\x03\x1C\n\x03\f\x03\x0E' +
    '\x03\x1F\v\x03\x03\x03\x03\x03\x03\x03\x06\x03$\n\x03\r\x03\x0E\x03%\x03' +
    '\x03\x03\x03\x03\x03\x03\x03\x05\x03,\n\x03\x03\x03\x02\x02\x02\x04\x02' +
    '\x02\x04\x02\x02\x02\x027\x02\x07\x03\x02\x02\x02\x04+\x03\x02\x02\x02' +
    '\x06\b\x05\x04\x03\x02\x07\x06\x03\x02\x02\x02\b\t\x03\x02\x02\x02\t\x07' +
    '\x03\x02\x02\x02\t\n\x03\x02\x02\x02\n\v\x03\x02\x02\x02\v\f\x07\x02\x02' +
    '\x03\f\x03\x03\x02\x02\x02\r,\x07\n\x02\x02\x0E,\x07\v\x02\x02\x0F,\x07' +
    '\f\x02\x02\x10,\x07\r\x02\x02\x11\x12\x07\x03\x02\x02\x12,\x05\x04\x03' +
    '\x02\x13\x14\x07\x04\x02\x02\x14,\x05\x04\x03\x02\x15\x16\x07\x05\x02' +
    '\x02\x16,\x05\x04\x03\x02\x17\x18\x07\x06\x02\x02\x18,\x05\x04\x03\x02' +
    '\x19\x1D\x07\x07\x02\x02\x1A\x1C\x05\x04\x03\x02\x1B\x1A\x03\x02\x02\x02' +
    '\x1C\x1F\x03\x02\x02\x02\x1D\x1B\x03\x02\x02\x02\x1D\x1E\x03\x02\x02\x02' +
    '\x1E \x03\x02\x02\x02\x1F\x1D\x03\x02\x02\x02 ,\x07\b\x02\x02!#\x07\x07' +
    '\x02\x02"$\x05\x04\x03\x02#"\x03\x02\x02\x02$%\x03\x02\x02\x02%#\x03' +
    "\x02\x02\x02%&\x03\x02\x02\x02&'\x03\x02\x02\x02'(\x07\t\x02\x02()\x05" +
    '\x04\x03\x02)*\x07\b\x02\x02*,\x03\x02\x02\x02+\r\x03\x02\x02\x02+\x0E' +
    '\x03\x02\x02\x02+\x0F\x03\x02\x02\x02+\x10\x03\x02\x02\x02+\x11\x03\x02' +
    '\x02\x02+\x13\x03\x02\x02\x02+\x15\x03\x02\x02\x02+\x17\x03\x02\x02\x02' +
    '+\x19\x03\x02\x02\x02+!\x03\x02\x02\x02,\x05\x03\x02\x02\x02\x06\t\x1D' +
    '%+';
class ProgramContext extends ParserRuleContext_1.ParserRuleContext {
    EOF() {
        return this.getToken(SchemeParser.EOF, 0);
    }
    expression(i) {
        if (i === undefined) {
            return this.getRuleContexts(ExpressionContext);
        }
        else {
            return this.getRuleContext(i, ExpressionContext);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return SchemeParser.RULE_program;
    }
    // @Override
    enterRule(listener) {
        if (listener.enterProgram) {
            listener.enterProgram(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitProgram) {
            listener.exitProgram(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitProgram) {
            return visitor.visitProgram(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ProgramContext = ProgramContext;
class ExpressionContext extends ParserRuleContext_1.ParserRuleContext {
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return SchemeParser.RULE_expression;
    }
    copyFrom(ctx) {
        super.copyFrom(ctx);
    }
}
exports.ExpressionContext = ExpressionContext;
class StringContext extends ExpressionContext {
    STRING() {
        return this.getToken(SchemeParser.STRING, 0);
    }
    constructor(ctx) {
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterString) {
            listener.enterString(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitString) {
            listener.exitString(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitString) {
            return visitor.visitString(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.StringContext = StringContext;
class NumberContext extends ExpressionContext {
    NUMBER() {
        return this.getToken(SchemeParser.NUMBER, 0);
    }
    constructor(ctx) {
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterNumber) {
            listener.enterNumber(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitNumber) {
            listener.exitNumber(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNumber) {
            return visitor.visitNumber(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.NumberContext = NumberContext;
class BoolContext extends ExpressionContext {
    BOOL() {
        return this.getToken(SchemeParser.BOOL, 0);
    }
    constructor(ctx) {
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterBool) {
            listener.enterBool(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitBool) {
            listener.exitBool(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBool) {
            return visitor.visitBool(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.BoolContext = BoolContext;
class IdentifierContext extends ExpressionContext {
    IDENTIFIER() {
        return this.getToken(SchemeParser.IDENTIFIER, 0);
    }
    constructor(ctx) {
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterIdentifier) {
            listener.enterIdentifier(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitIdentifier) {
            listener.exitIdentifier(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitIdentifier) {
            return visitor.visitIdentifier(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.IdentifierContext = IdentifierContext;
class QuoteContext extends ExpressionContext {
    expression() {
        return this.getRuleContext(0, ExpressionContext);
    }
    constructor(ctx) {
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterQuote) {
            listener.enterQuote(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitQuote) {
            listener.exitQuote(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitQuote) {
            return visitor.visitQuote(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.QuoteContext = QuoteContext;
class QuasiquoteContext extends ExpressionContext {
    expression() {
        return this.getRuleContext(0, ExpressionContext);
    }
    constructor(ctx) {
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterQuasiquote) {
            listener.enterQuasiquote(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitQuasiquote) {
            listener.exitQuasiquote(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitQuasiquote) {
            return visitor.visitQuasiquote(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.QuasiquoteContext = QuasiquoteContext;
class UnquoteContext extends ExpressionContext {
    expression() {
        return this.getRuleContext(0, ExpressionContext);
    }
    constructor(ctx) {
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterUnquote) {
            listener.enterUnquote(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitUnquote) {
            listener.exitUnquote(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUnquote) {
            return visitor.visitUnquote(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.UnquoteContext = UnquoteContext;
class UnquoteSplicingContext extends ExpressionContext {
    expression() {
        return this.getRuleContext(0, ExpressionContext);
    }
    constructor(ctx) {
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    // @Override
    enterRule(listener) {
        if (listener.enterUnquoteSplicing) {
            listener.enterUnquoteSplicing(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitUnquoteSplicing) {
            listener.exitUnquoteSplicing(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUnquoteSplicing) {
            return visitor.visitUnquoteSplicing(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.UnquoteSplicingContext = UnquoteSplicingContext;
class ListContext extends ExpressionContext {
    constructor(ctx) {
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    expression(i) {
        if (i === undefined) {
            return this.getRuleContexts(ExpressionContext);
        }
        else {
            return this.getRuleContext(i, ExpressionContext);
        }
    }
    // @Override
    enterRule(listener) {
        if (listener.enterList) {
            listener.enterList(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitList) {
            listener.exitList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitList) {
            return visitor.visitList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.ListContext = ListContext;
class DottedListContext extends ExpressionContext {
    constructor(ctx) {
        super(ctx.parent, ctx.invokingState);
        this.copyFrom(ctx);
    }
    expression(i) {
        if (i === undefined) {
            return this.getRuleContexts(ExpressionContext);
        }
        else {
            return this.getRuleContext(i, ExpressionContext);
        }
    }
    // @Override
    enterRule(listener) {
        if (listener.enterDottedList) {
            listener.enterDottedList(this);
        }
    }
    // @Override
    exitRule(listener) {
        if (listener.exitDottedList) {
            listener.exitDottedList(this);
        }
    }
    // @Override
    accept(visitor) {
        if (visitor.visitDottedList) {
            return visitor.visitDottedList(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
exports.DottedListContext = DottedListContext;
//# sourceMappingURL=SchemeParser.js.map